import { h } from 'preact'
import { useContext } from 'preact/hooks'
import { Context } from '../context/Context'
import { Actions, Views } from '../../enums'
import Body from '../blocks/Body'
import Container from '../blocks/Container'
import Footer from '../blocks/Footer'
import Heading from '../blocks/Heading'
import Button, { ButtonFormat } from '../elements/Button'
import HR from '../elements/HR'
import LI from '../elements/LI'
import P from '../elements/P'
import UL from '../elements/UL'

const DefaultView = () => {
  const globalState = useContext(Context)
  const { dispatch, state } = globalState

  const handleAccept = () => dispatch({
    type: Actions.accept
  })

  const handlePrivacyPolicy = () => {
    window.location.href = state.privacyPolicy
  }

  const handleViewChange = (event: any) => {
    const key = 'data-view'
    const view = Views[event.target.attributes[key].value] || Views.default
    return dispatch({ type: Actions.view, view })
  }

  const localizedCopy = state.copy[Views.default]

  window.$mediavine.newrelic.addPageAction('gdprModal', { layer: '1' })
  window.$mediavine.newrelic.addPageAction('gdprModal', { cmpLanguage: state.language })

  return (
    <Container color={state.color} view={Views.default}>
      <Heading view={Views.default}>
        <Heading.Title>
          { state.header ? (
            state.header
          ) : (
            state.title ? ([
              state.title,
              <br />,
              localizedCopy.heading
            ]) : (
              localizedCopy.heading
            )
          )}
        </Heading.Title>
      </Heading>
      <Body view={Views.default}>
        <HR />
        <P>
          {localizedCopy.details1.text1}
          <Button
            data-view={Views.partnerSettings}
            format={ButtonFormat.inline}
            onClick={handleViewChange}
          >
            {localizedCopy.details1.link1}
          </Button>
        </P>
        <UL>
          <LI>{localizedCopy.details1.purpose1}</LI>
        </UL>
        <HR />
        <P>
          {localizedCopy.details2.text1}
          <Button
            data-view={Views.partnerSettings}
            format={ButtonFormat.inline}
            onClick={handleViewChange}
          >
            {localizedCopy.details2.link1}
          </Button>
          {localizedCopy.details2.text2}
        </P>
        <UL>
          <LI>{localizedCopy.details2.stack26}</LI>
          <LI>{localizedCopy.details2.purpose10}</LI>
        </UL>
        <HR />
        <P>
          {localizedCopy.details3.text1}
          <Button
            data-view={Views.partnerSettings}
            format={ButtonFormat.inline}
            onClick={handleViewChange}
          >
            {localizedCopy.details3.link1}
          </Button>
          {localizedCopy.details3.text2}
        </P>
        <P>
          {localizedCopy.details4.text1}
          <Button
            format={ButtonFormat.inline}
            onClick={handlePrivacyPolicy}
          >
            {localizedCopy.details4.link1}
          </Button>
          {localizedCopy.details4.text2}
        </P>
        <HR />
      </Body>
      <Footer>
        <Footer.Row view={Views.default}>
          <Button
            data-view={Views.manageSettings}
            format={ButtonFormat.inverse}
            onClick={handleViewChange}
            view={Views.default}
          >
            {localizedCopy.controls.manageSettings}
          </Button>
          <Button
            color={state.color}
            format={ButtonFormat.primary}
            onClick={handleAccept}
            view={Views.default}
          >
            {localizedCopy.controls.accept}
          </Button>
        </Footer.Row>
      </Footer>
    </Container>
  )
}

export default DefaultView
